<template>
  <el-button :loading="isLoading" :type="type" :plain="plain" :size="size" @click="submit">
    {{ describe }}
  </el-button>
</template>

<script>
import throttle from '@/utils/throttle.js'
export default {
  props: {
    isAsync: {
      // 是否是异步
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default',
    },
    describe: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    plain: {
      type: Boolean,
      default: false,
    },
    myFunction: {
      type: Function,
      default() {},
    },
    msgBox: {
      // 是否需要二次确认弹窗
      type: Boolean,
      default: false,
    },
    msgBoxTitle: {
      type: String,
      default: '',
    },
    msgBoxMessage: {
      type: String,
      default: '',
    },
    confirmButtonText: {
      type: String,
      default: '确定',
    },
    cancelButtonText: {
      type: String,
      default: '取消',
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    submit() {
      if (!this.isAsync) return this.myFunction()

      if (this.msgBox) {
        this.$msgbox({
          title: this.msgBoxTitle,
          message: this.msgBoxMessage,
          showCancelButton: this.showCancelButton,
          confirmButtonText: this.confirmButtonText,
          cancelButtonText: this.cancelButtonText,
        })
          .then(action => {
            this.isLoading = true
            this.myFunction()?.finally(() => {
              this.isLoading = false
            })
          })
          .catch(action => {})
      } else {
        this.isLoading = true
        this.myFunction()?.finally(() => {
          this.isLoading = false
        })
      }
    },
  },
}
</script>
